<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("system log") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="tabs is-toggle is-fullwidth" ref="tabs">
          <ul>
            <li
              class="is-active"
              data-tab="general"
              @click="change_active_tab($event, this)"
            >
              <a>
                <i class="info icon" aria-hidden="true"></i>
                <span>{{ $t("general") }}</span>
              </a>
            </li>
            <li data-tab="request" @click="change_active_tab($event, this)">
              <a>
                <i class="key icon" aria-hidden="true"></i>
                <span>{{ $t("request") }}</span>
              </a>
            </li>
            <li data-tab="response" @click="change_active_tab($event, this)">
              <a>
                <i class="key icon" aria-hidden="true"></i>
                <span>{{ $t("response") }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="is-fluid" ref="contents" v-if="meta.create_user">
          <div class="" data-tab="general">
            <p class="title is-4">
              {{ $t("resource") }}: {{ meta.method }} {{ meta.path }}
            </p>
            <p class="title is-4">
              {{ $t("by") }} {{ meta.create_user.username }} -
              {{ format_date(meta.create_date) }}
              {{ format_time(meta.create_date) }}
            </p>
            <p class="subtitle is-4">{{ $t("origin") }}: {{ meta.origin }}</p>
            <!-- <pre> {{ meta }}</pre> -->
          </div>
          <div class="is-hidden" data-tab="request">
            <pre>{{ meta.request_data }}</pre>
          </div>
          <div class="is-hidden" data-tab="response">
            <pre>{{ response_data }}</pre>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button class="button is-rounded" @click="close_modal">
            {{ $t("close") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import {
  //   put,
  get,
  format_date,
  format_time,
  //   post,
  //   generate_error_message_text,
  change_active_tab,
} from "@/utils";

export default {
  name: "EnterpriseModal",
  components: {},
  data() {
    return {
      is_shown: false,
      meta: {},
    };
  },
  computed: {
    response_data() {
      let v = this;
      try {
        return JSON.stringify(JSON.parse(v.meta.response_data), null, 2);
      } catch (error) {
        return v.meta.response_data;
      }
    },
  },
  methods: {
    change_active_tab,
    format_date,
    format_time,
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
      get("/system/log", { uuid })
        .then((r) => {
          v.meta = r;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    set_initial_state() {
      this.meta = {};
    },
  },
  mounted() {
    // this.show_modal("42a7331a-099a-11ef-9b67-0800270c010e");
  },
};
</script>
<style></style>
